import React from "react";
import styles from "../Home.module.css"; // reuse your existing module or make a new one

export default function Report3({ goHome }) {
  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <header className={styles.header}>
          <div className={styles.logo}>
            <h1>U.S. NAVAL AERO</h1>
          </div>

          <div>
            <h2>Field Maintenance Ledger — FA/18 Service Section</h2>
            <p className={styles.lead}>
            </p>
          </div>

          <div className={styles.headerRight}>
            <div className={styles.stamp}>CLASSIFIED — TECH ONLY</div>
            <div style={{ fontSize: "12px", marginTop: "6px" }}>Form: EEB-18-2015</div>
          </div>
        </header>

        <section className={styles.reports}>
          <article className={styles.report}>
            <div className={styles.meta}>
              <div className={styles.left}>
                <strong>Service Report:</strong> FA/18 — BuNo 94512 (Avionics)
                <div style={{ fontSize: "12px", opacity: 0.9 }}>
                  Date: June 20, 2015 &nbsp; | &nbsp; Location: Radio Shop — Hangar 3
                </div>
              </div>
              <div className={styles.right}>
                Techs: S. P. Ellison (Radio Tech), A. Nguyen (Apprentice)
              </div>
            </div>

            <h3>Communications & Navigation Test</h3>
            <table className={styles.log}>
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Observation</th>
                  <th>Action Taken</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Transmitter — VHF</td>
                  <td>Intermittent carrier noted between 1,200–1,300 cycles; operator reported dropouts in heavy static.</td>
                  <td>Re-seated tube sockets; replaced rectifier tube (V-45). Carrier stable on bench; installed and retested on airframe — pass.</td>
                </tr>
                <tr>
                  <td>Radio Compass</td>
                  <td>Bearing error approx. +3°. Drift increases on turn.</td>
                  <td>Calibrated loop antenna; adjusted compensator coil per R-4 alignment chart; error reduced to +0.4° (within spec).</td>
                </tr>
                <tr>
                  <td>Intercom</td>
                  <td>Headset coupling noisy on RH panel.</td>
                  <td>Cleaned contacts and applied conductive grease; ordered replacement jack (JCK-22) for permanent repair.</td>
                </tr>
              </tbody>
            </table>

            <div className={styles.note}>
              Recommendation: Aircraft returned to flight status with restriction — avoid long-range IFR until replacement jack installed. 
              Documented in discrepancy book: D-56-114.
            </div>

            <div className={styles.sig}>
              <div className={styles.signBlock}>
                <span className={styles.signature}>S. P. Ellison</span>
                <div className={styles.initials}>Radio Tech — Hangar 3</div>
              </div>
              <div style={{ textAlign: "right" }}>
                <span className={styles.signature}>A. Nguyen</span>
                <div style={{ fontSize: "11px", color: "#554b3f" }}>Apprentice</div>
              </div>
            </div>
          </article>
        </section>

        <footer className={styles.footer}>
          <button onClick={() => goHome()} style={{ cursor: "pointer", border: "none", background: "none", color: "var(--accent)" }}>
            ← Back to Home
          </button>
        </footer>
      </div>
    </div>
  );
}
